import { render, staticRenderFns } from "./_DeleteFolder.vue?vue&type=template&id=10635cc0"
import script from "./_DeleteFolder.vue?vue&type=script&lang=js"
export * from "./_DeleteFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports